// Type scale tokens — this one file controls the whole widget's typography,
// the way colors.js controls its color. To retune the widget's text, edit
// only these values.
//
// The scale is shaped after Zoho CRM's own UI: Zoho Puvi, a tight step
// between sizes, and semibold (600) as the emphasis ceiling for chrome —
// Zoho's interface does not use true bold for card and section titles, which
// is most of why a widget that reaches for 700 reads heavier than the page
// hosting it. Sizes sit ~1-2px above Zoho's native scale so the widget stays
// comfortable to read inside the CRM iframe.
//
// The weights below resolve against the real Puvi faces declared in
// public/index.html, where each face is registered at its true CSS weight.

export const FONT_FAMILY =
  '"Zoho Puvi", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

// Sizes, in px.
//
// Pitched to sit level with Zoho CRM's own chrome rather than below it. Side
// by side against the CRM's left nav the previous scale read noticeably
// smaller, which makes an embedded widget feel like a cramped afterthought
// instead of part of the page. Everything moved up a step.
export const FS_MICRO = 13; // chips, badges, overline labels
export const FS_CAPTION = 14; // meta and helper text beneath a title
export const FS_BODY = 15; // default body copy, form labels, list rows
export const FS_SUBTITLE = 16; // emphasized row text
export const FS_TITLE = 18; // card and panel titles
export const FS_SECTION = 20; // sub-page section headings
export const FS_HEADING = 22; // page headings
export const FS_DISPLAY = 24; // empty states and dialog display text

// Line heights. Half of Zoho's readability is air, not size — tight leading
// on 15px text still reads cramped.
export const LH_BODY = 1.55;
export const LH_HEADING = 1.3;

// Weights. Zoho's chrome tops out at SEMIBOLD; keep BOLD for display text
// only, or the widget starts to out-shout the CRM page around it.
export const FW_REGULAR = 400;
export const FW_MEDIUM = 500;
export const FW_SEMIBOLD = 600;
export const FW_BOLD = 700;
